module.exports = __webpack_public_path__ + "static/media/dept-export.af935801.jpg";